import React from 'react';
// Components
import Navbar from '../../components/nav/Navbar';
import ForgotPasswordForm from '../../components/forms/ForgotPasswordForm';

function ForgettenPasswordPage() {
  return (
    <>
      {/* Page */}
      <div className='grid bg-colour4 text-colour2 dark:bg-colour4 dark:text-colour2 h-screen min-h-screen max-h-screen overflow-hidden w-full font-poppins'>
        <div className='grid grid-rows-reg w-full h-full'>
          {/* Navigation */}
          <Navbar />

          {/* Main page content */}
          <main role='main' className='grid w-full h-full overflow-hidden'>
            <div className='grid w-full h-full items-center py-2 px-10 overflow-hidden'>
              <section className='grid border-[1px] border-colour6 border-solid rounded-xl shadow-cardShadow w-full bg-colour1'>
                <div className='grid grid-rows-reg gap-4 w-full h-full px-6 py-6'>
                  {/* Header */}
                  <header className='grid text-center'>
                    <h1 className='text-3xl font-bold leading-tight tracking-tight font-gladolia text-colour2 md:text-2xl dark:text-colour6 '>
                      Reset Password
                    </h1>
                  </header>

                  {/* Login form */}
                  <section>
                    <ForgotPasswordForm />
                  </section>
                </div>
              </section>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}

export default ForgettenPasswordPage;
